import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width || 30}
      height={props.height || 30}
      viewBox="0 0 29 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.225 0H1.555C.696 0 0 .696 0 1.555v26.89C0 29.304.696 30 1.555 30h3.076l9.759-1.137L24.149 30h3.076c.859 0 1.555-.697 1.555-1.555V1.555C28.78.696 28.084 0 27.225 0z"
        fill="#E9A577"
      />
      <path
        d="M1.81 28.445V1.555C1.81.696 2.508 0 3.367 0h-1.81C.695 0 0 .696 0 1.555v26.89C0 29.304.696 30 1.555 30h1.811a1.556 1.556 0 01-1.555-1.555z"
        fill="#E48949"
      />
      <path
        d="M21.4 6.032a2.134 2.134 0 00.88-1.921 2.136 2.136 0 00-4.005-.837 1.61 1.61 0 01-1.418.82h-4.935a1.61 1.61 0 01-1.418-.82A2.136 2.136 0 107.38 6.032a2.135 2.135 0 00-.88 1.921 2.136 2.136 0 004.005.837 1.61 1.61 0 011.417-.82h4.936a1.61 1.61 0 011.418.82A2.136 2.136 0 1021.4 6.032z"
        fill="#E9E9E9"
      />
      <path
        d="M10.187 15.439c-1.773-2.34-3.433-1.525-4.308-.228-.387.573-.844.6-1.458.724-1.01.205-1.155 1.437-.91 2.264.352 1.192 1.726 1.702 2.862 1.438l3.814-4.198zM18.593 15.439c1.773-2.34 3.433-1.525 4.308-.228.387.573.844.6 1.458.724 1.01.205 1.155 1.437.91 2.264-.352 1.192-1.726 1.702-2.862 1.438l-3.814-4.198z"
        fill="#D2614C"
      />
      <path
        d="M10.218 30H4.631c0-4.537.362-15.503 9.759-15.503 9.396 0 9.759 10.966 9.759 15.503h-5.587l-4.172-1.137L10.218 30z"
        fill="#E9E9E9"
      />
      <path
        d="M18.593 29.527c0 .16-.01.318-.03.473h-8.344a3.586 3.586 0 01-.031-.473c0-2.132 1.88-3.86 4.202-3.86s4.203 1.728 4.203 3.86z"
        fill="#D2614C"
      />
      <path
        d="M15.398 21.025h-2.016c-.4 0-.513.548-.145.707.35.15.741.235 1.153.235.412 0 .803-.084 1.153-.235.368-.159.256-.707-.145-.707zM10.143 19.814a.453.453 0 00-.453.453v.769a.453.453 0 10.906 0v-.769a.453.453 0 00-.453-.453zM18.637 19.814a.453.453 0 00-.453.453v.769a.453.453 0 00.905 0v-.769a.453.453 0 00-.452-.453zM16.567 22.541a.453.453 0 00-.639.043.79.79 0 01-.598.261.792.792 0 01-.6-.26.458.458 0 00-.34-.155.457.457 0 00-.34.154.792.792 0 01-.6.261.791.791 0 01-.599-.26.453.453 0 10-.682.595c.317.363.784.57 1.281.57.34 0 .666-.097.94-.275.273.178.6.276.94.276.497 0 .963-.208 1.28-.571a.453.453 0 00-.043-.639z"
        fill="#424952"
      />
    </svg>
  );
}

export default SvgComponent;
